export enum OrderResultType {
    Create = 'created',
    Regenerate = 'regenerate',
    Reorder = 'reorder'
}
